import { type FC } from 'react';
import { Form } from 'react-bootstrap';

import { ChartXAxisType, ChartDateFormat } from '@soomo/lib/types/index';

interface Props {
	chartProperties: any;
	tabsUIEnabled: boolean;
	onChange: (_) => void;
}

const LineChartFields: FC<Props> = (props) => {
	const { chartProperties, tabsUIEnabled, onChange } = props;

	return (
		<>
			<div className="block">
				<Form.Group>
					<Form.Label>Category axis type</Form.Label>
					<Form.Control
						as="select"
						className="select"
						value={chartProperties.x_axis_type}
						onChange={(e) => onChange({ x_axis_type: e.target.value })}>
						{Object.keys(ChartXAxisType).map((type) => (
							<option key={type} value={ChartXAxisType[type]}>
								{type}
							</option>
						))}
					</Form.Control>
				</Form.Group>

				{chartProperties.x_axis_type === ChartXAxisType.date && (
					<Form.Group>
						<Form.Label>Date format</Form.Label>
						<Form.Control
							as="select"
							value={chartProperties.date_format}
							onChange={(e) => onChange({ date_format: e.target.value })}>
							{Object.keys(ChartDateFormat).map((type) => (
								<option key={type} value={ChartDateFormat[type]}>
									{type}
								</option>
							))}
						</Form.Control>
					</Form.Group>
				)}

				<Form.Group>
					<Form.Label>Category axis ticks every</Form.Label>
					<Form.Control
						type="number"
						step={1}
						value={chartProperties.x_ticks}
						className="number"
						onChange={(e) => onChange({ x_ticks: e.target.value })}
					/>
				</Form.Group>
			</div>

			{tabsUIEnabled && (
				<div className="block">
					<Form.Check
						type="checkbox"
						checked={!!chartProperties.show_markers}
						onChange={() => onChange({ show_markers: !chartProperties.show_markers })}
						label="Show markers"
					/>
				</div>
			)}

			<div className="block">
				<Form.Group>
					<Form.Label>Category axis title</Form.Label>
					<Form.Control
						value={chartProperties.x_axis_label}
						placeholder="Category axis title"
						onChange={(e) => onChange({ x_axis_label: e.target.value })}
					/>
				</Form.Group>

				<Form.Group>
					<Form.Label>Value axis title</Form.Label>
					<Form.Control
						value={chartProperties.y_axis_label}
						placeholder="Value axis title"
						onChange={(e) => onChange({ y_axis_label: e.target.value })}
					/>
				</Form.Group>
			</div>

			<div className="block">
				<Form.Group>
					<Form.Check
						type="checkbox"
						checked={!!chartProperties.fill_line}
						onChange={(e) => onChange({ fill_line: !chartProperties.fill_line })}
						label="Fill area under lines"
					/>
				</Form.Group>

				<Form.Group>
					<Form.Label>Line width</Form.Label>
					<Form.Control
						type="number"
						step={1}
						value={chartProperties.line_stroke_width}
						className="number"
						onChange={(e) => onChange({ line_stroke_width: e.target.value })}
					/>
				</Form.Group>
			</div>
		</>
	);
};

export default LineChartFields;
